export default __webpack_public_path__ + "static/media/qt-icon.bdff7c4c.webp";